const fr: Record<string, string> = {
  'common.return': 'Retour',
  'common.cancel': 'Annuler',
  'common.save': 'Enregistrer',
  'common.create': 'Créer',
  'common.update': 'Modifier',
  'common.edit': 'Modifier',
  'common.delete': 'Supprimer',
  'common.archive': 'Archiver',
  'common.restore': 'Restaurer',
  'common.close': 'Fermer',
  'common.filter': 'Filtrer',
  'common.loading': 'Chargement...',
  'common.error': 'Erreur :',
  'common.success': 'Succès !',
  'common.noData': 'Aucune donnée',
  'common.none': 'Aucune',
  'common.home': 'Accueil',
  'common.admin': 'Admin',
  'common.installApp': "Installer l'app",
  'common.installAppIOSHint':
    'Appuyez sur le bouton Partager dans Safari, puis "Sur l\'écran d\'accueil" pour installer cette app.',
  'common.installAppGenericHint':
    'Utilisez le menu de votre navigateur et cherchez "Ajouter à l\'écran d\'accueil" ou "Installer l\'application".',
  'common.created': 'Créé le',
  'common.actions': 'Actions',
  'common.name': 'Nom',
  'common.confirm': 'Confirmer',
  'common.project': 'Projet',
  'common.saving': 'Enregistrement...',
  'common.previousVersion': 'Version précédente',
  'common.nextVersion': 'Version suivante',
  'common.viewingVersionNumber': 'Version {{number}} sur {{total}}',
  'common.createdBy': 'Créé le',
  'common.updatedBy': 'Modifié le',
  'common.forceOnDashboard': 'Afficher sur le tableau de bord',
  'common.removeDate': 'Supprimer la date',

  'iconPicker.searchPlaceholder': 'Rechercher une icône...',
  'iconPicker.noResults': 'Aucune icône trouvée',
  'iconPicker.section.general': 'Général',
  'iconPicker.section.tasks': 'Tâches & suivi',
  'iconPicker.section.calendar': 'Calendrier & temps',
  'iconPicker.section.documents': 'Documents & fichiers',
  'iconPicker.section.media': 'Média & musique',
  'iconPicker.section.people': 'Communication & personnes',
  'iconPicker.section.groceries': 'Courses',

  'auth.signIn': 'Connexion à votre compte',
  'auth.magicLinkHint':
    'Nous vous enverrons un lien magique pour vous connecter',
  'auth.email': 'Adresse e-mail',
  'auth.emailPlaceholder': 'utilisateur@exemple.com',
  'auth.sendMagicLink': 'Envoyer le lien magique',
  'auth.sending': 'Envoi en cours...',
  'auth.checkEmail':
    'Vérifiez votre e-mail ({{email}}) pour le lien de connexion !',
  'auth.verifying': 'Vérification de votre lien magique...',
  'auth.invalidLink': 'Lien de vérification invalide',
  'auth.verificationError': "Une erreur s'est produite lors de la vérification",
  'auth.requestNewLink': 'Demander un nouveau lien magique',
  'auth.emailNotFound': 'Aucun compte trouvé pour cette adresse e-mail.',
  'auth.sessionEndedReason': 'Vous avez été déconnecté : {{reason}}',
  'auth.sessionEndedTechnical': 'Détail technique : {{detail}}',

  'status.active': 'Actif',
  'status.pending': 'En attente',
  'status.archived': 'Archivé',

  'roles.Admin': 'Admin',
  'roles.Advanced user': 'Utilisateur avancé',
  'roles.User': 'Utilisateur',
  'roles.noRoles': 'Aucun rôle assigné',

  'profile.title': 'Profil',
  'profile.personalInfo': 'Informations personnelles',
  'profile.accountInfo': 'Informations du compte',
  'profile.firstName': 'Prénom :',
  'profile.lastName': 'Nom :',
  'profile.gender': 'Genre :',
  'profile.documentId': 'ID du document :',
  'profile.login': 'Identifiant :',
  'profile.email': 'E-mail :',
  'profile.roles': 'Rôles :',
  'profile.logout': 'Déconnexion',
  'profile.close': 'Fermer',
  'profile.language': 'Langue',
  'profile.languageLabel': "Langue d'affichage",
  'profile.toolbarPlacement': 'Barre d\'actions',
  'profile.toolbarPlacementLabel': 'Où afficher les icônes d\'actions rapides ?',
  'profile.toolbarPlacementOff': 'Masquée (menu uniquement)',
  'profile.toolbarPlacementHeader': "Dans l'en-tête",
  'profile.toolbarPlacementFooter': 'Dans le pied de page',
  'profile.represents': 'Représentation',
  'profile.representsPerson': 'Personne représentée',
  'profile.representsNone': 'Aucune représentation assignée',

  'admin.people': 'Personnes',
  'admin.peopleSubtitle':
    'Gérer les utilisateurs, les personnes et leurs relations',
  'admin.people.usersTab': 'Utilisateurs',
  'admin.people.personsTab': 'Personnes',
  'admin.people.representsTab': 'Représentations',
  'admin.people.sendMagicLink': 'Envoyer le lien',
  'admin.people.generateMagicLink': 'Obtenir le lien',
  'admin.people.magicLinkSent': 'Lien magique envoyé à {{email}}',
  'admin.people.magicLinkError': 'Impossible de traiter le lien magique',
  'admin.people.magicLinkFor': 'Lien magique pour {{email}}',
  'admin.people.magicLinkWarning':
    "Ce lien donne un accès direct au compte. Partagez-le de manière sécurisée et uniquement avec l'utilisateur concerné.",
  'admin.people.copyLink': 'Copier le lien',
  'admin.people.copied': 'Copié !',
  'admin.people.sendNotification': 'Envoyer une notification',
  'admin.editUser': "Modifier l'utilisateur",
  'admin.userNotFound': 'Utilisateur introuvable',
  'admin.editTribe': 'Modifier la tribu',
  'admin.tribeNotFound': 'Tribu introuvable',
  'admin.tribeInfo': 'Informations de la tribu',
  'admin.users': 'Utilisateurs',
  'admin.usersSubtitle': 'Gérer les comptes utilisateurs et les rôles',
  'admin.persons': 'Personnes',
  'admin.columnPersons': 'Membres',
  'admin.filterByPerson': 'Filtrer par personne',
  'admin.allPersons': 'Toutes les personnes',
  'admin.noTribeMembers': 'Aucun membre',
  'admin.personsSubtitle': 'Gérer les personnes',
  'admin.authorization': 'Autorisations',
  'admin.authorizationSubtitle': 'Gérer les rôles et les permissions',
  'admin.authorization.rolesTab': 'Rôles',
  'admin.authorization.permissionsTab': 'Permissions',
  'admin.roles': 'Rôles',
  'admin.rolesSubtitle': 'Gérer les rôles et les permissions',
  'admin.permissions': 'Permissions',
  'admin.permissionsSubtitle': 'Gérer les permissions',
  'admin.positions': 'Positions',
  'admin.positionsSubtitle': 'Gérer les positions',
  'admin.represents': 'Représentations',
  'admin.representsSubtitle': 'Gérer les représentations utilisateur–personne',
  'admin.tribesProjects': 'Tribus & Projets',
  'admin.tribes': 'Tribus',
  'admin.tribesSubtitle': 'Gérer les tribus',
  'admin.projects': 'Projets',
  'admin.projectsSubtitle': 'Gérer les projets',
  'admin.documents': 'Documents',
  'admin.documentsSubtitle': 'Gérer les documents et le contenu',
  'admin.monitoring': 'Suivi',
  'admin.monitoringSubtitle': 'Modifications récentes sur toutes les entités',
  'admin.mails.nav': 'Mails',
  'admin.mails.title': 'Mails',
  'admin.mails.subtitle': "Mails sortants et leur statut d'envoi",
  'admin.mails.mailType': 'Type de mail',
  'admin.mails.subject': 'Objet',
  'admin.mails.mailStatus': "Statut d'envoi",
  'admin.mails.allMailStatuses': 'Tous les statuts',
  'mail_status.sent': 'Envoyé',
  'mail_status.not_sent': 'Non envoyé',
  'admin.mails.plannedAt': 'Prévu le',
  'admin.mails.sentAt': 'Envoyé le',
  'admin.mails.recipients': 'Destinataires',
  'admin.mails.noRecipients': 'Aucun destinataire',
  'admin.mails.content': 'Contenu',
  'admin.mails.noMails': 'Aucun mail trouvé pour les filtres sélectionnés',
  'admin.monitoringHours': 'Afficher les modifications des dernières',
  'admin.monitoringHoursUnit': 'heures',
  'monitoring.entity': 'Entité',
  'monitoring.id': 'ID',
  'monitoring.summary': 'Résumé',
  'monitoring.createdAt': 'Créé le',
  'monitoring.createdBy': 'Créé par',
  'monitoring.updatedAt': 'Modifié le',
  'monitoring.updatedBy': 'Modifié par',
  'monitoring.status': 'Statut',
  'monitoring.noChanges': 'Aucune modification dans cette fenêtre de temps',
  'monitoring.filterByUser': 'Utilisateur',
  'monitoring.filterByUserPlaceholder': 'utilisateur@exemple.com',
  'monitoring.filterByStatus': 'Statut',
  'monitoring.allStatuses': 'Tous les statuts',
  'monitoring.allUsers': 'Tous les utilisateurs',
  'monitoring.revisions.link': 'Révisions',
  'monitoring.revisions.title': 'Révisions du document',
  'monitoring.revisions.documentId': 'ID du document',
  'monitoring.revisions.list': 'Révisions',
  'monitoring.revisions.none': 'Aucune révision enregistrée pour ce document.',
  'monitoring.revisions.selectOne': 'Sélectionnez une révision dans la liste.',
  'monitoring.revisions.loadError': 'Impossible de charger les révisions.',
  'monitoring.revisions.older': 'Plus ancienne',
  'monitoring.revisions.newer': 'Plus récente',
  'monitoring.revisions.current': 'Actuelle',
  'admin.app': 'Application',
  'admin.addUser': 'Utilisateur',
  'admin.addPerson': 'Personne',
  'admin.addRole': 'Rôle',
  'admin.addPermission': 'Permission',
  'admin.addPosition': 'Ajouter une position',
  'admin.addRepresents': 'Ajouter une représentation',
  'admin.tribe': 'Tribu',
  'admin.addTribe': 'Ajouter une tribu',
  'admin.addProject': 'Ajouter un projet',
  'admin.addDocument': 'Document',
  'admin.deleteSelectedUsers': 'Supprimer les utilisateurs sélectionnés',
  'admin.deleteSelectedPersons': 'Supprimer les personnes sélectionnées',
  'admin.deleteSelectedRoles': 'Supprimer les rôles sélectionnés',
  'admin.deleteSelectedPermissions': 'Supprimer les permissions sélectionnées',
  'admin.deleteSelectedPositions': 'Supprimer les positions sélectionnées',
  'admin.deleteSelectedRepresents':
    'Supprimer les représentations sélectionnées',
  'admin.deleteSelectedTribes': 'Supprimer les tribus sélectionnées',
  'admin.deleteSelectedProjects': 'Supprimer les projets sélectionnés',
  'admin.deleteSelectedDocuments': 'Supprimer les documents sélectionnés',
  'admin.deleteUser': "Supprimer l'utilisateur",
  'admin.deletePerson': 'Supprimer la personne',
  'admin.deleteRole': 'Supprimer le rôle',
  'admin.deletePermission': 'Supprimer la permission',
  'admin.deletePosition': 'Supprimer la position',
  'admin.deleteRepresents': 'Supprimer la représentation',
  'admin.deleteTribe': 'Supprimer la tribu',
  'admin.deleteProject': 'Supprimer le projet',
  'admin.deleteDocument': 'Supprimer le document',
  'admin.confirmDeleteSelected':
    'Êtes-vous sûr de vouloir supprimer {{count}} élément(s) ?',
  'admin.confirmDeleteUser': 'Êtes-vous sûr de vouloir supprimer {{login}} ?',
  'admin.confirmDeletePerson': 'Êtes-vous sûr de vouloir supprimer {{name}} ?',
  'admin.confirmDeleteNamed':
    'Êtes-vous sûr de vouloir supprimer « {{name}} » ?',
  'admin.confirmDeletePosition':
    'Êtes-vous sûr de vouloir supprimer cette position ?',
  'admin.confirmDeleteRepresents':
    'Êtes-vous sûr de vouloir supprimer cette représentation ?',
  'admin.confirmDeleteDocument':
    'Êtes-vous sûr de vouloir supprimer ce document ?',
  'admin.deleteSelected': 'Sélection ({{count}})',
  'admin.searchLoginEmail': 'Rechercher par identifiant ou e-mail...',
  'admin.searchNameGenderDate': 'Rechercher par nom, genre, date...',
  'admin.searchNameDesc': 'Rechercher par nom ou description...',
  'admin.searchName': 'Rechercher par nom...',
  'admin.searchContent': 'Rechercher par contenu...',
  'admin.searchPositionType': 'Rechercher par type de position...',
  'admin.searchRepresents': 'Rechercher par utilisateur ou personne...',
  'admin.columnUser': 'Utilisateur',
  'admin.columnRoles': 'Rôles',
  'admin.columnPermissions': 'Permissions',
  'admin.columnDocument': 'Document',
  'admin.columnTribe': 'Tribu',
  'admin.columnPosition': 'Position',
  'admin.columnPerson': 'Personne',
  'admin.columnContentSummary': 'Résumé du contenu',
  'admin.columnAttachments': 'Pièces jointes',
  'admin.attached': '✓ Associé',
  'admin.none': 'Aucun',
  'admin.files': '{{count}} fichier(s)',
  'admin.foundResults': '{{count}} résultat(s)',
  'admin.genderMale': 'Homme',
  'admin.genderFemale': 'Femme',
  'admin.genderOther': 'Autre',
  'admin.genderPreferNot': 'Préfère ne pas préciser',
  'admin.columnProject': 'Projet',
  'admin.config': 'Configuration',
  'admin.configSubtitle': 'Gérer les valeurs de configuration',
  'admin.config.key': 'Clé',
  'admin.config.value': 'Valeur',
  'admin.config.description': 'Description',
  'admin.config.descriptionPlaceholder': 'Ce que ce paramètre contrôle...',
  'admin.config.addEntry': 'Ajouter',
  'admin.config.entry': 'Entrée',
  'admin.notifications': 'Notifications',
  'admin.notifications.title': 'Notifications',
  'admin.notifications.subtitle': 'Envoyer des notifications aux utilisateurs',
  'admin.notifications.searchPlaceholder': 'Rechercher des utilisateurs…',
  'admin.notifications.name': 'Nom',
  'admin.notifications.email': 'Email',
  'admin.notifications.sendAction': 'Envoyer une notification',
  'admin.notifications.modalTitle': 'Envoyer une notification à {{name}}',
  'admin.notifications.messagePlaceholder': 'Saisissez votre message…',
  'admin.notifications.send': 'Envoyer',
  'admin.notifications.success': 'Notification programmée pour {{name}}',
  'admin.notifications.error': "Échec de l'envoi de la notification",
  'admin.notifications.noResults':
    'Aucun utilisateur trouvé. Tapez pour rechercher.',
  'admin.notifications.history': 'Historique',
  'admin.notifications.historyEmpty': 'Aucune notification envoyée pour le moment.',
  'admin.notifications.historyRecipient': 'Destinataire',
  'admin.notifications.historyMessage': 'Message',
  'admin.notifications.historyStatus': 'Statut',
  'admin.notifications.historyScheduledFor': 'Planifiée pour',
  'admin.notifications.historyDate': 'Date',
  'admin.notifications.status.planned': 'En attente',
  'admin.notifications.status.sent': 'Envoyée',
  'admin.notifications.status.failed': 'Échec',

  'validation.errorOccurred': "Une erreur s'est produite. Veuillez réessayer.",

  'search.title': 'Recherche',
  'search.subtitle': 'Recherchez dans les documents auxquels vous avez accès.',
  'search.placeholder': 'Rechercher...',
  'search.empty': 'Aucun résultat trouvé pour votre recherche.',
  'search.highlightBanner': 'Résultat pour : {{token}}',
  'search.removeHighlight': 'Surimpression',

  'footer.allRightsReserved': '© {{year}} Modern Tribes. Tous droits réservés.',
  'footer.privacy': 'Confidentialité',
  'footer.terms': "Conditions d'utilisation",
  'footer.help': 'Aide',

  'files.attachments': 'Pièces jointes',
  'files.attachFiles': 'Joindre des fichiers',
  'files.uploading': 'Téléversement...',
  'files.maxSize': 'Max {{maxFiles}} fichiers, {{maxFileSize}} Mo chacun',
  'files.maxFilesError': '{{maxFiles}} fichiers maximum autorisés',
  'files.fileSizeError':
    'Le fichier {{filename}} dépasse la limite de {{maxFileSize}} Mo',
  'files.uploadFailed': 'Échec du téléversement',

  'labels.edit': 'label',
  'labels.delete': 'label',
  'labels.moveUp': 'Monter',
  'labels.moveDown': 'Descendre',
  'labels.manage': 'Gérer les labels',
  'labels.none': 'Aucun label pour le moment',
  'labels.newLabelPlaceholder': 'Nom du nouveau label',
  'labels.createLabel': 'Créer le label',
  'labels.confirmDelete': 'Supprimer « {{name}} » ?',
  'labels.confirmDeleteInUse': 'Supprimer « {{name}} » ? Utilisé par {{count}} élément(s).',

  'layout.toolbarConfigure': 'Configurer la barre d\'outils',
  'layout.toolbarConfigureDirect': 'Directe',
  'layout.toolbarConfigureInMenu': 'Dans le menu',

  'theme.selectTheme': 'Thème',

  'calendar.allDay': 'Toute la journée',
  'calendar.midnight': 'Minuit',
  'calendar.noItemsDay': 'Rien ce jour.',
  'calendar.noItemsWeek': 'Rien cette semaine.',

  'about.title': 'À propos',
  'about.subtitle':
    'Modern Tribes — un outil léger pour organiser les groupes auxquels vous appartenez.',
  'about.sourceCode': 'Code source',
  'about.stack': 'Stack technique',
  'about.backendStack': 'Backend',
  'about.frontendStack': 'Frontend',
  'about.features': 'Fonctionnalités',
  'about.platform': 'Plateforme',
  'about.platformCore': 'Noyau',
  'about.platformFunctions': 'Fonctions',
  'about.platformTools': 'Outils',
  'about.subPackages': 'Sous-packages',
  'about.application': 'Modules applicatifs',

  'install.title': 'Installer Modern Tribes',
  'install.subtitle':
    "Ajoutez l'application à votre écran d'accueil pour la meilleure expérience",
  'install.ios.title': 'Installer sur iPhone / iPad',
  'install.ios.safariRequired': "Ouvrir dans Safari d'abord",
  'install.ios.safariRequiredDesc':
    "Cette page doit être ouverte dans Safari pour installer l'application. Appuyez sur l'icône de partage dans votre navigateur et choisissez « Ouvrir dans Safari ».",
  'install.ios.step1': 'Appuyez sur le bouton Partager',
  'install.ios.step1desc':
    "L'icône de partage se trouve en bas de la barre Safari (flèche vers le haut)",
  'install.ios.step2': "Appuyez sur « Sur l'écran d'accueil »",
  'install.ios.step2desc':
    'Faites défiler le menu de partage pour trouver cette option',
  'install.ios.step3': 'Appuyez sur « Ajouter »',
  'install.ios.step3desc': 'Confirmez en appuyant sur Ajouter en haut à droite',
  'install.android.title': 'Installer sur Android',
  'install.android.inAppBrowserTitle': "Ouvrir dans Chrome d'abord",
  'install.android.inAppBrowserDesc':
    "Vous êtes dans un navigateur intégré (ex. Gmail). Appuyez sur le menu et choisissez « Ouvrir dans Chrome » pour installer.",
  'install.android.openInChrome1': 'Appuyez sur le menu de votre navigateur',
  'install.android.openInChrome1desc':
    'Cherchez ⋮ ou une icône de partage en haut à droite',
  'install.android.openInChrome2': 'Appuyez sur « Ouvrir dans Chrome »',
  'install.android.openInChrome2desc':
    "Ou « Ouvrir dans le navigateur » — choisissez Chrome",
  'install.android.openInChrome3': 'Installer depuis Chrome',
  'install.android.openInChrome3desc':
    "Une fois dans Chrome, appuyez sur le bouton Installer qui apparaît ici",
  'install.android.installButton': "Installer l'application",
  'install.android.installing': 'Installation…',
  'install.android.manualTitle': 'Ou installez manuellement via Chrome :',
  'install.android.manual1': 'Ouvrez le menu Chrome',
  'install.android.manual1desc':
    'Appuyez sur le menu à trois points (⋮) en haut à droite',
  'install.android.manual2': "Appuyez sur « Installer l'application »",
  'install.android.manual2desc':
    "Ou « Ajouter à l'écran d'accueil » sur les anciennes versions de Chrome",
  'install.android.manual3': "Confirmez l'installation",
  'install.android.manual3desc':
    "Appuyez sur « Installer » pour ajouter l'application à votre écran d'accueil",
  'install.android.apkTitle': "Télécharger l'application directement",
  'install.android.apkDesc':
    "Pas besoin de Chrome — téléchargez l'APK et installez-le directement.",
  'install.android.apkButton': "Télécharger l'APK",
  'install.android.apkWarning':
    "Vous devrez peut-être autoriser l'installation depuis des sources inconnues dans Paramètres Android → Applications → Accès spécial.",
  'install.desktop.title': 'Ouvrir sur votre téléphone',
  'install.desktop.desc':
    "Visitez cette adresse sur votre Android ou iPhone pour installer l'application :",
  'install.version.upToDate': 'Vous êtes à jour (version {{version}})',
  'install.version.updateAvailable': 'Mise à jour disponible : version {{version}}',
  'install.version.updateDesc': "Une nouvelle version de l'application est disponible. Téléchargez l'APK pour mettre à jour.",
  'install.version.backToApp': "Retour à l'application",
  'notifications.deniedBanner.message':
    "Les notifications sont bloquées. Pour les réactiver, ouvrez Chrome → appuyez sur l'icône cadenas à côté de la barre d'adresse → Paramètres du site → Notifications → Autoriser.",
  'notifications.deniedBanner.dismiss': 'Ignorer',
};

export default fr;
